import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TASK_PRIORITY } from '../../../core/helpers/constants';
import { createGuid } from '../../../core/helpers/utility';
import { IClient } from '../../../core/models/clients.models';
import { ITask } from '../../../core/models/tasks.models';
import * as moment from 'moment'
import { TasksApiService } from '../../../pages/tasks/tasks.apiservice';
import * as _ from 'underscore'
import { Utility } from '../../../shared/utility';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'modal-create-task-external',
  templateUrl: './create-task-external.component.html',
  styleUrls: ['./create-task-external.component.scss']
})

export class CreateTaskExternalModal implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  @Output() oSaveClicked = new EventEmitter<any>();

  public TASK_PRIORITY = TASK_PRIORITY;

  addTaskForm!: FormGroup;
  submitted = false;

  @Input() set iClientId(value: any) {
    if (value !== null)
      this.addTaskForm.controls['clientId'].patchValue(value);
  }
  @Input() set iCampaignId(value: any) {
    if (value !== null)
      this.addTaskForm.controls['campaignId'].patchValue(value);
  }
  @Input() set iUserId(value: any) {
    if (value !== null)
      this.addTaskForm.controls['assignedUserId'].patchValue(value);
  }

  id: number = -1;

  constructor(
    private taskService: TasksApiService,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private translate: TranslateService) {
    
    this.addTaskForm = this.formBuilder.group({
      id: [null],
      test: [null],
      title: ['', [Validators.required]],
      priority: [2, [Validators.required]],
      campaignId: [null],
      clientId: [null],
      dueDate: [moment().format('YYYY-MM-DDT17:00:00.000Z'), Validators.required],
      description: ['', [Validators.required]],
      assignedUserId: ['', [Validators.required]],
      isCompleted: [null]
    });
    
  }

  get f() { return this.addTaskForm.controls; }

  updateData(data: IClient) {
    this.addTaskForm.patchValue(data);
  }

  ngOnInit() {

  }


  onSubmit() {
    this.submitted = true;

    if (this.addTaskForm.invalid) {
      console.warn('Form is invalid:', this.addTaskForm.errors);
      return;
    }
    if (this.f.id.value === null || this.f.id.value === -1)
      this.f.id.setValue(createGuid())

    if (this.f.campaignId.value === -1)
      this.f.campaignId.setValue(null);
    if (this.f.clientId.value === -1)
      this.f.clientId.setValue(null);

    let formValues: ITask = this.addTaskForm.value;

    formValues = this.trimObjectStrings(formValues);

    const prefix = this.translate.instant('CLIENT_REQUEST_PREFIX');
    if (formValues.title && !formValues.title.startsWith(prefix)) {
      formValues.title = prefix + ' ' + formValues.title;
    }

    formValues.description = [
      formValues.description,
      `${this.translate.instant('REQUEST_MADE_AT')}: ${new Date().toLocaleString()}`
    ].join('\n\n');

    formValues.dueDate = Utility.getTaskDueDateFromDateTime(formValues.dueDate);

    this.taskService.saveTask(formValues).pipe(takeUntil(this.destroyed$)).subscribe((response: any) => {
      if (response && response.good) {
        this.activeModal.close('saved');
        Swal.fire({
          icon: 'success',
          title: this.translate.instant('URGENT_REQUEST_FORM.SWAL_SUCCESS_TITLE'),
          text: this.translate.instant('URGENT_REQUEST_FORM.SWAL_SUCCESS_TEXT'),
          confirmButtonText: this.translate.instant('OK')
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: this.translate.instant('ERROR'),
          text: this.translate.instant('URGENT_REQUEST_FORM.SWAL_ERROR_TEXT'),
          confirmButtonText: this.translate.instant('OK')
        });
      }
    });
  }

  // This function will recursively iterate through the object
  trimObjectStrings(obj: any): any {
    // Iterate over each property of the object
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        
        if (typeof value === 'string') {
          // Trim the string if the value is a string
          obj[key] = value.trim();
        } else if (typeof value === 'object' && value !== null) {
          // Recursively call the function if the value is an object (or array)
          this.trimObjectStrings(value);
        }
      }
    }
    return obj;
  }

  close() {
    this.activeModal.dismiss();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
